import { render } from "./BankLoans.vue?vue&type=template&id=2ccf43c7&scoped=true"
import script from "./BankLoans.vue?vue&type=script&lang=js"
export * from "./BankLoans.vue?vue&type=script&lang=js"

import "./BankLoans.vue?vue&type=style&index=0&id=2ccf43c7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ccf43c7"]])

export default __exports__